var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBellNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 29,
    viewBox: "0 0 25 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8416 5.25956C13.3246 5.25956 14.4719 5.56495 14.4719 5.56495C17.5803 6.27725 19.7681 9.14034 19.7681 12.3729V20.1729V21.0737L20.4037 21.7122L20.9347 22.2456H4.61221L5.14321 21.7122L5.77873 21.0737V20.1729V12.3729C5.77873 9.1404 7.96662 6.27725 11.075 5.56495C11.075 5.56495 12.3052 5.25956 12.7053 5.25956H12.8416ZM12.7734 0.318359C11.5733 0.318359 10.6558 1.24004 10.6558 2.44563V3.43829C6.63203 4.36031 3.59691 8.04745 3.59691 12.3729V20.1729L0.773438 23.0093V24.4275H24.7734V23.0093L21.95 20.1729V12.3729C21.95 8.04745 18.9148 4.36031 14.8911 3.43829V2.44563C14.8911 1.24004 13.9736 0.318359 12.7734 0.318359ZM15.5969 25.8456H9.94989C9.94989 27.4057 11.2203 28.682 12.7734 28.682C14.3266 28.682 15.5969 27.4057 15.5969 25.8456Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellNotification);
export default __webpack_public_path__ + "static/media/bell-notification.e4ffe99233f81d10e5fa9c8af1a3f4cd.svg";
export { ForwardRef as ReactComponent };